import type { Action } from 'redux';

import normaliseError, { type NormaliseErrorInput } from '/shared/functions/normaliseError';
import type { NormalisedError } from '/index';

export interface InitiativeQuestionDataState {
  fetching: boolean;
  fetched: boolean | null;
  error: NormalisedError | null;
  answerUnit: string;
  answerUnitInSentence: string;
  rootAnswerValue: number;
  baseAnswerValue: number;
  answerWithReductionAppliedValue: number;
}

interface InitiativeRequestQuestionResourceRejectedAction extends Action {
  type: 'INITIATIVE_REQUEST_QUESTION_RESOURCE_REJECTED';
  error: NormaliseErrorInput;
}

interface InitiativeRequestQuestionResourceResetAction extends Action {
  type: 'INITIATIVE_REQUEST_QUESTION_RESOURCE_RESET';
}

interface InitiativeRequestQuestionResourceStartAction extends Action {
  type: 'INITIATIVE_REQUEST_QUESTION_RESOURCE_START';
}

interface InitiativeRequestQuestionResourceFulfilledAction extends Action {
  type: 'INITIATIVE_REQUEST_QUESTION_RESOURCE_FULFILLED';
  questionData: {
    answerUnit: string;
    rootAnswerValue: number;
    baseAnswerValue: number;
    answerWithReductionAppliedValue: number;
    answerUnitInSentence: string;
  };
}

type InitiativeQuestionDataAction =
  | InitiativeRequestQuestionResourceRejectedAction
  | InitiativeRequestQuestionResourceResetAction
  | InitiativeRequestQuestionResourceStartAction
  | InitiativeRequestQuestionResourceFulfilledAction;

const defaultState: InitiativeQuestionDataState = {
  fetching: false,
  fetched: null,
  error: null,
  answerUnit: 'unit',
  answerUnitInSentence: 'unit',
  rootAnswerValue: 0,
  baseAnswerValue: 0,
  answerWithReductionAppliedValue: 0,
};

function reducer(
  state: InitiativeQuestionDataState = defaultState,
  action: InitiativeQuestionDataAction,
): InitiativeQuestionDataState {
  switch (action.type) {
    case 'INITIATIVE_REQUEST_QUESTION_RESOURCE_REJECTED': {
      const { error } = action;
      return {
        ...defaultState,
        error: normaliseError(error),
        fetching: false,
        fetched: true,
      };
    }
    case 'INITIATIVE_REQUEST_QUESTION_RESOURCE_RESET': {
      return {
        ...defaultState,
        fetching: false,
        fetched: null,
      };
    }
    case 'INITIATIVE_REQUEST_QUESTION_RESOURCE_START': {
      return {
        ...defaultState,
        fetching: true,
        fetched: false,
      };
    }

    case 'INITIATIVE_REQUEST_QUESTION_RESOURCE_FULFILLED': {
      const { questionData } = action;
      const { answerUnit, rootAnswerValue, baseAnswerValue, answerWithReductionAppliedValue, answerUnitInSentence } =
        questionData;
      return {
        ...state,
        answerUnit,
        rootAnswerValue,
        baseAnswerValue,
        answerUnitInSentence,
        answerWithReductionAppliedValue,
        error: null,
        fetching: false,
        fetched: true,
      };
    }
    default:
      return state;
  }
}

export default reducer;
